import { PublicationCodes } from '@/scopes/common/domain/models'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { cn } from '@sunwebgroup/uds-ui/utils'
import React from 'react'
import styles from './Hero.module.css'

export const MAX_HERO_IMAGE_WIDTH = 1440

interface HeroProps {
  title: string
  imageSlot: React.ReactNode
  destinationSelectorSlot: React.ReactNode
}

function Hero({
  title,
  imageSlot,
  destinationSelectorSlot,
}: HeroProps) {
  const publicationCode = useConfiguration('publicationCode')
  const siteClass = PublicationCodes.isElizaPublicationCode(publicationCode) ? styles.eliza : styles.sunweb

  return (
    <div className={cn(styles.hero, siteClass)}>
      {imageSlot}
      <section className={styles.heroContent}>
        <Typography as="h1" variant="display-e-regular">
          {title}
        </Typography>
        {destinationSelectorSlot}
      </section>
    </div>
  )
}

export default Hero
